// extracted by mini-css-extract-plugin
export default {"fr-view":"Zone_fr-view__HX6Nv","zone":"Zone_zone__+SGVp","shape-rectangle":"Zone_shape-rectangle__2Xfdx","shape-circle":"Zone_shape-circle__9SRrb"};